import { render, staticRenderFns } from "./ShopOffers.vue?vue&type=template&id=54f3ee1b&scoped=true"
import script from "./ShopOffers.vue?vue&type=script&lang=ts"
export * from "./ShopOffers.vue?vue&type=script&lang=ts"
import style0 from "./ShopOffers.vue?vue&type=style&index=0&id=54f3ee1b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54f3ee1b",
  null
  
)

export default component.exports